import React, { Key, useContext } from "react"
import BaseDocumentElement from "../../../../components/elements/BaseDocumentElement"
import { DocumentDataType } from "../../../../components/types"
import { PR } from "../../../../data/Types"
import dayjs from "dayjs"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import BaseSectionHeadline from "../../../../components/elements/BaseSectionHeadline"
import { formatCurrency } from "../../../../services/functions"

type BillDetailPaymentsAndFilesType = {
    connectedPaymentRequirements: PR[]
    setpayment: (item: PR) => void
    data: {
        additional_s3Documents: DocumentDataType[]
    }
    handleDownload: (item: { s3Key: string; filename: string }) => void
    handleChangePreviewElement: (e: string) => void
}

export default function BillDetailPaymentsAndFiles(props: BillDetailPaymentsAndFilesType) {
    const modalCon = useContext(ModalContext)

    return (
        <div className="mt-4 w-full h-fit lg:max-h-[16vh] rounded-default shadow-lg bg-white p-4 flex lg:flex-row flex-col gap-4 lg:gap-0">
            <div className="flex flex-col w-full">
                <BaseSectionHeadline small label={"Zugeordnete Zahlungsanforderungen"} />
                <div className="overflow-y-scroll">
                    {!props.connectedPaymentRequirements || props.connectedPaymentRequirements.length === 0 ? (
                        <p className="text-center uppercase text-sm text-gray-300 font-medium pt-1">Keine Zahlungen zugeordnet</p>
                    ) : (
                        props.connectedPaymentRequirements?.map((item: PR, index: Key) => (
                            <PaymentRow
                                key={index}
                                item={item}
                                openModal={() => {
                                    props.setpayment(item)
                                    modalCon?.trigger(16)
                                }}
                            />
                        ))
                    )}
                </div>
            </div>
            <div className="flex flex-col w-full">
                <BaseSectionHeadline small label={"Zugeordnete Dateien"} />
                <div className="overflow-y-scroll">
                    {!props.data.additional_s3Documents || props.data.additional_s3Documents.length === 0 ? (
                        <p className="text-center uppercase text-sm text-gray-300 font-medium pt-1">Keine Dokumente hochgeladen</p>
                    ) : (
                        props.data?.additional_s3Documents.map((item: DocumentDataType, index: Key) => (
                            <BaseDocumentElement
                                key={index}
                                title={item.title}
                                timestamp={item.timestamp}
                                showPreviewFunc={() => props.handleChangePreviewElement(item.s3Key)}
                                downloadFunc={() => props.handleDownload({ s3Key: item.s3Key, filename: item.title })}
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    )
}

type PaymentRowType = {
    item: PR
    openModal: () => void
}

function PaymentRow(props: PaymentRowType) {
    return (
        <div className="w-full flex flex-row flex-wrap items-center gap-4 p-2 text-sm">
            <div className="flex flex-row items-center gap-4">
                <p className=" text-gray-400 h-fit">Erstellt am:</p>
                <p>{dayjs(props.item.invoice_date).format("DD.MM.YYYY")}</p>
            </div>
            <div className="flex flex-row items-center gap-4">
                <p className=" text-gray-400 h-fit">Fällig am:</p>
                <p>{dayjs(props.item.due_date).format("DD.MM.YYYY")}</p>
            </div>
            <div className="flex flex-row items-center gap-4">
                <p className=" text-gray-400 h-fit">Betrag:</p>
                <p>{formatCurrency(props.item.expected_payment)}</p>
            </div>
                <p className=" text-gray-400 h-fit">Status:</p>
                <p
                className={`${
                    props.item.status === "settled" ? "text-green-500" : props.item.status === "unpaid" ? "text-red-600" : "text-gray-400"
                } font-medium`}>
                {props.item.status === "settled" ? "Beglichen" : props.item.status === "unpaid" ? "Offen" : "Storniert"}
            </p>
            {props.item.status !== "canceled" && props.item.status !== "settled" && (
                <button className="btn btn-sm btn-ghost" onClick={props.openModal}>
                    Mahnung
                </button>
            )}
        </div>
    )
}
